export default "__VITE_ASSET__DxGvWCi7__"